import { type AxiosInstance } from 'axios'
import { Cached } from '@coris-ts/helpers/utilities'
import { PollsApiDataSource } from './data/api/polls.api-datasource'
import { type PollsDataSource } from './data/polls.datasource'
import { GetPollsInteractor } from './domain/interactors/get-polls.interactor'
import { GetPollInteractor } from './domain/interactors/get-poll.interactor'
import { SavePollInteractor } from './domain/interactors/save-poll.interactor'
import { ClosePollInteractor } from './domain/interactors/close-poll.interactor'
import { DeletePollInteractor } from './domain/interactors/delete-poll.interactor'
import { GetLinkablePostsInteractor } from './domain/interactors/get-linkable-posts.interactor'

export interface PollsComponent {
  provideGetPolls: () => GetPollsInteractor
  provideGetPoll: () => GetPollInteractor
  provideSavePoll: () => SavePollInteractor
  provideClosePoll: () => ClosePollInteractor
  provideDeletePoll: () => DeletePollInteractor
  provideGetLinkablePosts: () => GetLinkablePostsInteractor
}

export class PollsDefaultModule implements PollsComponent {
  constructor(
    private readonly baseUrl: string,
    private readonly axios: AxiosInstance,
    private readonly getOrganizationSlug: () => string | undefined
  ) {}

  @Cached()
  private getDataSource(): PollsDataSource {
    return new PollsApiDataSource(this.baseUrl, this.axios, this.getOrganizationSlug)
  }

  public provideGetPolls(): GetPollsInteractor {
    return new GetPollsInteractor(this.getDataSource())
  }

  public provideGetPoll(): GetPollInteractor {
    return new GetPollInteractor(this.getDataSource())
  }

  public provideSavePoll(): SavePollInteractor {
    return new SavePollInteractor(this.getDataSource())
  }

  public provideClosePoll(): ClosePollInteractor {
    return new ClosePollInteractor(this.getDataSource())
  }

  public provideDeletePoll(): DeletePollInteractor {
    return new DeletePollInteractor(this.getDataSource())
  }

  public provideGetLinkablePosts(): GetLinkablePostsInteractor {
    return new GetLinkablePostsInteractor(this.getDataSource())
  }
}
